import Button from "../../../../../design-system/components/Button/Button.jsx";
import { Variants } from "../../../../../design-system/components/Button/Variants.jsx";
import Header from "../../../../../design-system/components/Header/Header.jsx";
import { buttonContainer } from "./ShowroomHeader.css.ts";

/**
 * Represents the header component for a showroom page.
 *
 * @param {Object} props - The properties object for the component.
 * @param {boolean} [props.isDarkMode=false] - Indicates whether dark mode is enabled for the header.
 * @param {string} [props.publicShowroomButtonTarget] - The target URL for the public showroom button. If null, no button is displayed.
 * @param {string} [props.uploadEditButtonTarget] - The target URL for the upload/edit button. If null, no button is displayed.
 @param {boolean} props.hasExistingShowroomEntry - Indicates whether the user has already uploaded a showroom entry.
 * @returns {JSX.Element} The header component for the showroom page.
 */
export const ShowroomHeader = ({
  isDarkMode = false,
  publicShowroomButtonTarget,
  uploadEditButtonTarget,
  hasExistingShowroomEntry,
}) => {
  return (
    <Header title={"Showroom"} isDarkMode={isDarkMode} backPath={".."} back>
      <div className={buttonContainer}>
        {publicShowroomButtonTarget && (
          <Button
            to={publicShowroomButtonTarget}
            variant={Variants.QUATERNARY}
            width={"fit-content"}
          >
            Zum Event Showroom
          </Button>
        )}
        {uploadEditButtonTarget && (
          <Button
            iconRight={hasExistingShowroomEntry ? "pencil" : "arrowupload"}
            width="fit"
            to={uploadEditButtonTarget}
          >
            {hasExistingShowroomEntry ? "Mein Beitrag" : "Hochladen"}
          </Button>
        )}
      </div>
    </Header>
  );
};
